import React from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Box, ListRow, Text } from '@betterment/samba-react';

import { StyledLinkRow, titleCss } from '../../../../../Shared/components-v2/styled-link-row/StyledLinkRow';
import { ThemedImage } from '../../../../../Shared/components-v2/themed-image/ThemedImage';
import { urlBuilder } from '../../../../../Shared/urlBuilder';
import { PerformanceAccountsQuery } from '../graphql/performanceAccounts.generated';

type Props = { account: PerformanceAccountsQuery['performance']['accounts'][number] };

export const AccountRow: React.FC<Props> = ({ account }) => {
  const { id: accountId, icon: accountIcon, name: accountName, balance, envelope } = account;
  const { purpose } = envelope;
  const name = purpose?.name || accountName;
  const icon = purpose?.image || accountIcon;

  return (
    <StyledLinkRow to={urlBuilder.appAccountPerformance.absolute({ accountId })} name={name}>
      <ListRow.LeadingAsset>
        <Box css={{ width: '36px', height: '36px' }}>
          <ThemedImage themedAsset={icon} alt={`${name} icon`} />
        </Box>
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <Text color="text" css={titleCss}>
          {name}
        </Text>
        {purpose && (
          <Text color="text.weak" variant="text50">
            {accountName}
          </Text>
        )}
      </ListRow.LeadingContent>
      <ListRow.TrailingContent css={{ alignItems: 'end' }}>
        <Text color="text">{formatMoney(balance)}</Text>
      </ListRow.TrailingContent>
    </StyledLinkRow>
  );
};
